import React, { useState } from "react";
import { 
  EditOptionContainer, 
  EditOptionTitle, 
  EditOptionDescription, 
  FormGroup, 
  Button, 
  ButtonGroup,
  LoadingSpinner,
  TipBox
} from "../EditOptionStyles";
import { eraseForeground } from "../../utils/editUtils";

const EraseForeground = ({ onSubmit, isLoading }) => {
  const handleSubmit = () => {
    onSubmit({
      editType: "eraseForeground",
      options: {},
      apiFunction: eraseForeground
    });
  };

  return (
    <EditOptionContainer>
      <div>
        <EditOptionTitle icon="👻">Erase Foreground</EditOptionTitle>
        <EditOptionDescription>
          Automatically remove all foreground objects from your image while preserving and generating a clean background.
        </EditOptionDescription>
      </div>

      <div style={{
        padding: "1.5rem",
        backgroundColor: "#f8fafd",
        borderRadius: "8px",
        border: "1px solid #dde3ed",
        textAlign: "center",
        marginBottom: "1.5rem"
      }}>
        <div style={{ fontSize: "2.5rem", marginBottom: "0.75rem" }}>✨</div>
        <div style={{ fontWeight: "500", color: "#333", marginBottom: "0.5rem" }}>
          One-Click Foreground Removal
        </div>
        <div style={{ color: "#666", fontSize: "0.9rem" }}>
          This tool automatically detects and removes all foreground objects, leaving you with a clean background scene.
        </div>
      </div>

      <TipBox 
        title="What This Does" 
        icon="💡"
      >
        This feature intelligently identifies foreground subjects (people, objects, etc.) and removes them while generating appropriate background content to fill the space.
      </TipBox>

      <ButtonGroup>
        <Button 
          onClick={handleSubmit} 
          disabled={isLoading}
          style={{ width: "100%" }}
        >
          {isLoading ? (
            <>
              <LoadingSpinner />
              Processing...
            </>
          ) : (
            "Erase Foreground"
          )}
        </Button>
      </ButtonGroup>
    </EditOptionContainer>
  );
};

export default EraseForeground;
